import React, { useEffect, useState } from 'react';
import { API_URL, apiFetch } from '../../../config/api';
import { Agent } from '../../../types/flzhub';
import { Card, getAgentColor, getAgentInitials, getRoleLabel } from './Shared';

const MEDALS = ['🥇', '🥈', '🥉'];

export const FlzTests: React.FC = () => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch(`${API_URL}/api/flzhub/leaderboard`)
      .then(r => r.json())
      .then(d => {
        // leaderboard endpoint array veya {agents:[]} döndürebilir
        const list = Array.isArray(d) ? d : (d.agents ?? d.leaderboard ?? []);
        setAgents(list);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--os-muted)', fontSize: 11 }}>Loading leaderboard...</div>;

  const top3 = agents.slice(0, 3);

  return (
    <div style={{ height: '100%', overflowY: 'auto', padding: 20 }}>
      {/* Top 3 podium */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
        {top3.map((a, i) => (
          <Card key={a.id} style={{
            textAlign: 'center', padding: 20,
            border: i === 0 ? '1px solid #f59e0b' : '1px solid var(--os-card-border)',
            background: i === 0 ? 'linear-gradient(135deg, rgba(245,158,11,0.1), transparent)' : 'var(--os-card)',
          }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>{MEDALS[i]}</div>
            <div style={{ fontSize: 13, fontWeight: 800 }}>{a.agent_name}</div>
            <div style={{ fontSize: 9, color: 'var(--os-muted)', marginBottom: 10 }}>{getRoleLabel(a.id)}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: i === 0 ? '#f59e0b' : '#6366f1' }}>
              {a.eq_score?.toFixed(1)} <span style={{ fontSize: 9, fontWeight: 400 }}>EQ</span>
            </div>
            <div style={{ fontSize: 9, color: 'var(--os-muted)', marginTop: 4 }}>
              Lv.{a.level} · {a.total_xp?.toLocaleString()} XP
            </div>
          </Card>
        ))}
      </div>

      {/* Full table */}
      <Card>
        <div style={{ fontSize: 10, color: 'var(--os-muted)', marginBottom: 8 }}>
          {agents.length} agents ranked
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
          <thead>
            <tr style={{ color: 'var(--os-muted)', borderBottom: '2px solid var(--os-border)' }}>
              <th style={{ padding: '10px 8px', textAlign: 'left' }}>#</th>
              <th style={{ padding: '10px 8px', textAlign: 'left' }}>Agent</th>
              <th style={{ padding: '10px 8px', textAlign: 'center' }}>EQ</th>
              <th style={{ padding: '10px 8px', textAlign: 'center' }}>XP</th>
              <th style={{ padding: '10px 8px', textAlign: 'center' }}>Tier</th>
            </tr>
          </thead>
          <tbody>
            {agents.map((a, i) => (
              <tr key={a.id} style={{ borderBottom: '1px solid var(--os-border)' }}>
                <td style={{ padding: '8px', fontWeight: 800, color: i < 3 ? '#f59e0b' : 'var(--os-muted)', fontSize: 10 }}>{i + 1}</td>
                <td style={{ padding: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 22, height: 22, borderRadius: '50%', background: getAgentColor(a.agent_name), color: '#fff', fontSize: 8, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {getAgentInitials(a.agent_name)}
                    </div>
                    <span style={{ fontWeight: 600 }}>{a.agent_name}</span>
                  </div>
                </td>
                <td style={{ padding: '8px', textAlign: 'center', fontWeight: 800, color: (a.eq_score || 0) >= 8.5 ? '#10b981' : '#6366f1' }}>
                  {a.eq_score?.toFixed(1)}
                </td>
                <td style={{ padding: '8px', textAlign: 'center', color: 'var(--os-muted)' }}>
                  {a.total_xp?.toLocaleString()}
                </td>
                <td style={{ padding: '8px', textAlign: 'center' }}>
                  <span style={{ fontSize: 8, background: 'rgba(255,255,255,0.05)', padding: '2px 5px', borderRadius: 4 }}>
                    {a.mertebe_level || 'NASUT'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
};
